import EquipmentCases from "./EquipmentCases";

export default EquipmentCases;
